import { render, staticRenderFns } from "./SidebarOverdue.vue?vue&type=template&id=4025a198"
import script from "./SidebarOverdue.vue?vue&type=script&lang=js"
export * from "./SidebarOverdue.vue?vue&type=script&lang=js"
import style0 from "./SidebarOverdue.vue?vue&type=style&index=0&id=4025a198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports